"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsDev = getIsDev;
var cache = undefined;
function getIsDev() {
    if (cache !== undefined) {
        return cache;
    }
    var isDev = (function () {
        if (/https?:\/\/localhost/.test(window.location.href)) {
            return true;
        }
        if (typeof process === "object" &&
            process !== null &&
            process.env instanceof Object &&
            process.env.NODE_ENV !== "production") {
            return true;
        }
        if (document.querySelector('script[type="module"][src="/@vite/client"]') !== null) {
            return true;
        }
        return false;
    })();
    return (cache = isDev);
}
//# sourceMappingURL=isDev.js.map